module.exports = "/_next/static/images/favicon-060c283b7f1a7f327ded20da06e050e7.png";